module.exports = __webpack_public_path__ + "img/parents-manage-record-active.0c895ea8.svg";